import React, { ReactElement } from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { HStack } from "web/react/emo/h-stack";
import { VStack } from "web/react/emo/v-stack";
import { View } from "web/react/emo/view";
import { LabelledRow } from "web/react/pages/account/order-history/labelled-row";
import { RetailerOrderCard } from "web/react/pages/account/order-history/retailer-order-card";
import { gettext } from "web/script/modules/django-i18n";
import { formatDateMDYWithSeparator } from "web/script/utils/dates";
import { CheckoutOrderHistorySerializer } from "web/types/serializers";
import * as styles from "./order-card.css";

export function OrderCard({ order }: { order: CheckoutOrderHistorySerializer }): ReactElement {
    return (
        <a href={`${order.id}/`} className={styles.orderCardLink}>
            <View
                padding="sm"
                border="keyline"
                borderColor="grayscale300"
                borderRadius="md"
                className={styles.orderCard}
            >
                <VStack spacing="sm">
                    <div className={styles.orderInfoContainer}>
                        <HStack spacing="xs">
                            <SVGIcon name="calendar" className={styles.icon} />
                            <LabelledRow
                                label={gettext("order_history.orders.date")}
                                value={formatDateMDYWithSeparator(order.date_created)}
                            />
                        </HStack>

                        <HStack spacing="xs">
                            <SVGIcon name="shopping-basket" className={styles.icon} />
                            <LabelledRow
                                label={gettext("order_history.orders.lyst_order_no")}
                                value={order.reference}
                            />
                        </HStack>
                    </div>

                    <div className={styles.separator} />

                    <VStack spacing="md">
                        {order.retailer_orders.map((retailerOrder, index) => (
                            <RetailerOrderCard
                                key={`retailer_order_${index}`}
                                retailerOrder={retailerOrder}
                            />
                        ))}
                    </VStack>
                </VStack>
            </View>
        </a>
    );
}
